import { app } from "@thomasphan/vue-components/src/functions/initializeApp";
import { getAuth, connectAuthEmulator  } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://192.168.1.13:9100');
  connectFirestoreEmulator(db, '192.168.1.13', 8200);
  connectStorageEmulator(storage, '192.168.1.13', 9199);
}
